import styled from "styled-components";

export const MenuNav = styled.div`
  display: inherit;
  flex: 0 0 8.72%;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
`;
